import { isProd, isStage } from 'helpers';

export function appendFeedbackScript(username: string) {
  const projectName = 'shome';
  const LOAD_DELAY = 4000;

  const sfbScriptUrl = `https://sfb${isStage ? '-stage' : ''}.samoletgroup.ru/v1/static/sfb.js`;

  const sfbScript = document.createElement('script');

  sfbScript.type = 'text/javascript';
  sfbScript.src = sfbScriptUrl;

  sfbScript.onload = () => {
    (window as any).sfb && isProd && (window as any).sfb.run(projectName, username); // eslint-disable-line
  };

  setTimeout(() => {
    document.body.appendChild(sfbScript);
  }, LOAD_DELAY);
}
